// BOT-1521: a membership tier can carry a sign-up (one-time) fee and a
// recurring fee at the same time. Each fee is switched on, named and priced
// independently, and maps to its own nested-attributes key on the tier.

export const blankOneTimeFee = () => ({ enabled: false, id: null, custom_name: '', flat_rate_cents: 0 })

export const blankRecurringFee = () => ({
  ...blankOneTimeFee(),
  interval_type: 'order_amount',
  interval_amount: 0
})

export const blankMembershipFees = () => ({ oneTime: blankOneTimeFee(), recurring: blankRecurringFee() })

export const oneTimeFeeFromServer = fee => {
  if (!fee) return blankOneTimeFee()

  return {
    enabled: true,
    id: fee.id,
    custom_name: fee.attributes.custom_name || '',
    flat_rate_cents: fee.attributes.flat_rate_cents || 0
  }
}

export const recurringFeeFromServer = fee => {
  if (!fee) return blankRecurringFee()

  return {
    ...oneTimeFeeFromServer(fee),
    interval_type: fee.attributes.interval_type || 'order_amount',
    interval_amount: fee.attributes.interval_amount || 0
  }
}

// Nested attributes for one fee: create/update it while enabled, destroy it
// once disabled, and send nothing when there is nothing on the server to remove.
const feeAttributes = (fee, extraAttributes = {}) => {
  if (!fee.enabled) {
    return fee.id ? { id: fee.id, _destroy: true } : null
  }

  return {
    ...(fee.id ? { id: fee.id } : {}),
    flat_rate_cents: parseInt(fee.flat_rate_cents) || 0,
    custom_name: fee.custom_name || '',
    ...extraAttributes
  }
}

export const membershipFeeAttributes = ({ oneTime, recurring }) => {
  const attributes = {
    one_time_membership_fee_attributes: feeAttributes(oneTime),
    recurring_membership_fee_attributes: feeAttributes(recurring, {
      interval_type: recurring.interval_type,
      interval_amount: parseInt(recurring.interval_amount) || 0
    })
  }

  return Object.fromEntries(Object.entries(attributes).filter(([, value]) => value))
}
